import { whenElse } from '@genesislcap/foundation-utils';
import { html, ref, when } from '@microsoft/fast-element';
import { TabsOrientation } from '@microsoft/fast-foundation';
import { getPrefix } from '../utils';
export const getPrefixedStepperTab = (prefix) => html `
  ${whenElse((x) => x.orientation === TabsOrientation.vertical, html `
        <${prefix}-tree-item ${ref('treeItem')} class="tree-item">
          ${when((x) => x.completed, html `
              <${prefix}-icon
                name="check-circle"
                variant="regular"
                size="lg"
                class="stepper-icon completed-icon"
              ></${prefix}-icon>
            `)}
          ${when((x) => x.error, html `
              <${prefix}-icon
                name="times-circle"
                variant="regular"
                size="lg"
                class="stepper-icon error-icon"
              ></${prefix}-icon>
            `)}
          <slot></slot>
        </${prefix}-tree-item>
      `, html `
      <div class="step-number-container">
        <span class="step-number">${(x) => x.tabPosition}</span>
        <slot class="step-title"></slot>
        ${when((x) => !x.isLast, html `
              <${prefix}-icon
                class="stepper-icon angle-icon"
                name="angle-right"
                variant="solid"
                size="lg"
              ></${prefix}-icon>
            `)}
      </div>
    `)}
`;
export const foundationStepperTabTemplate = html `
  ${(x) => getPrefixedStepperTab(getPrefix(x))}
`;
